import { Button, VoiceOrb } from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface PracticeDebriefOverlayProps {
  /** Writing the feedback gave up, or never came. */
  failed: boolean;
  linkOnly: boolean;
  onRetry: () => void;
  onLeave: () => void;
}

/**
 * Over a conversation that has ended while its feedback is written. Opaque,
 * and over this surface rather than the window: half a ghosted stage under a
 * translucent film reads as a rendering fault, not as "writing your feedback".
 */
export function PracticeDebriefOverlay({
  failed,
  linkOnly,
  onRetry,
  onLeave,
}: PracticeDebriefOverlayProps) {
  return (
    <div className='absolute inset-0 z-10 flex flex-col items-center justify-center gap-4 bg-canvas px-5 text-center'>
      {failed ? (
        <>
          <p role='alert' className='text-base text-ink-body'>
            {m.practice_session_debrief_failed()}
          </p>
          <div className='flex flex-wrap items-center justify-center gap-3'>
            <Button onClick={onRetry}>{m.practice_session_debrief_retry()}</Button>
            {!linkOnly && (
              <Button variant='quiet' onClick={onLeave}>
                {m.practice_back()}
              </Button>
            )}
          </div>
        </>
      ) : (
        <>
          <VoiceOrb state='thinking' />
          <p className='text-base text-ink-body'>{m.practice_session_ending()}</p>
        </>
      )}
    </div>
  );
}
